import axios from "axios";

export const API = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

export const http = axios.create({ baseURL: API });

http.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("gv_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function saveAuth(token, user) {
  localStorage.setItem("gv_token", token);
  localStorage.setItem("gv_user", JSON.stringify(user));
}
export function clearAuth() {
  localStorage.removeItem("gv_token");
  localStorage.removeItem("gv_user");
}
export function currentUser() {
  try {
    return JSON.parse(localStorage.getItem("gv_user") || "null");
  } catch {
    return null;
  }
}
